import React,{Component, Fragment} from 'react';
import {
    HashRouter as Router,
    Link,
    Switch,
    Route
} from 'react-router-dom'
import ReactTooltip from "react-tooltip";
import {constants} from '../constants';
import axios from 'axios';

//Components
import Layout from './pageLayout';
import Drawing from '../component/drawing';
import Standard from '../component/standard'
import Equipments from "../component/equipments";
import Modal from './modal';
import Form from '../component/form'
import utility from "../utility";

class Enquiry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            drawing: [],
           /* standard: [{
                "da": "21",
                "db": "32",
                "dc": "32",
                "product": "t1",
                "productUrl": "http://www.kantmanufaktur.com/themes/mauer/images/products/t1.png",
                "crossSlope": "",
                "crossSlopeMM": 0.5584770059930724,
                "crossSlopeDeg": "1",
                "runninMeter": "32m",
                "cuttingLength": "3m",
                "sheetThickness": "1,5mm",
                "bracketSpace": "0,5m",
                "color": "Pulver Sonderfarbe RAL 1001 beige",
                "type": "Aussenecke",
                "anzahl": 0,
                "winkel": 0,
                "menge": 0,
                "links": 0,
                "currentProduct": 0,
                "productId": 0,
                "editUpdated": true,
                "overHangOutside": "32mm",
                "overHangInside": "32mm",
                "customLaufmeter": [12536, 86895, 665865]
            }, {
                "da": "21",
                "db": "32",
                "dc": "32",
                "product": "t2",
                "productUrl": "http://www.kantmanufaktur.com/themes/mauer/images/products/t2.png",
                "crossSlope": "",
                "crossSlopeMM": 1.116783894480031,
                "crossSlopeDeg": "2",
                "runninMeter": "233m",
                "cuttingLength": "3m",
                "sheetThickness": "2,5mm",
                "bracketSpace": "0,5m",
                "color": "RAL 1005 Honey yellow",
                "type": "Aussenecke",
                "anzahl": 0,
                "winkel": 0,
                "menge": 0,
                "links": 0,
                "currentProduct": 1,
                "productId": 1,
                "editUpdated": false,
                "overHangInside": "32mm",
                "overHangOutside": "32mm"
            }],*/
            standard:[],
            /*equipments: [{
                "selectedEq": "Wechselecke",
                "height": 0,
                "panelSize": "3000mm",
                "length": 0,
                "pieces": "2",
                "url": "http://www.kantmanufaktur.com/themes/mauer/images/products/Wechselecke.jpg",
                "Linke Blende": {"value": 0, "label": "Standard Nr.1"},
                "Rechte Blende": {"value": 1, "label": "Standard Nr.2"},
                "winkel": "45∠",
                "links": "1000",
                "rechts": "1000"
            }],*/
            equipments:[],
            enquiry: {},
            form: {},
            standardVisilble: "d-none",
            drawingVisilble: "d-none",
            navVisible: "",
            equip: [
                {
                    name: "Aufkantung",
                    url: constants.IMG_URL + "Aufkantung.jpg"
                },
                {
                    name: "Außenecke",
                    url: constants.IMG_URL + "Außenecke.jpg"
                },
                {
                    name: "Endkappe",
                    url: constants.IMG_URL + "Endkappe.jpg"
                },
                {
                    name: "Innenecke",
                    url: constants.IMG_URL + "Innenecke.jpg"
                },
                {
                    name: "T-Formteil",
                    url: constants.IMG_URL + "Tformteil.jpg"
                },
                {
                    name: "Wechselecke",
                    url: constants.IMG_URL + "Wechselecke.jpg"
                }
            ],
            currentEquipment: 0,
            place: "top",
            type: "dark",
            effect: "float",
            showModal: "",
            currentEdit: "",
            editId: false
        }

        this.save = this.save.bind(this);
        this.proxyClick = this.proxyClick.bind(this);
        this.removeResult = this.removeResult.bind(this);
        this.select = this.select.bind(this);
        this.onChange = this.onChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.finalSubmit = this.finalSubmit.bind(this);
        this.resetEdit = this.resetEdit.bind(this);
        this.changeVariations = this.changeVariations.bind(this);
        this.customLaufmeterTextBox=React.createRef();
    }

    save(data, type, isArray = true, edit = false) {
        let d = utility.objectCopy(this.state[type]);
        if (edit === false) {
            d = isArray ? d.concat(data) : data;
        } else {
            d[edit] = data;
        }

        this.setState({[type]: d}, () => {
            console.log("submitted", data);
        });
    }

    removeResult(key, type) {
        let arr = this.state[type];
        let newarr = [...arr];
        newarr.splice(key, 1);
        this.setState({[type]: newarr})
    }

    proxyClick(id) {
        document.getElementById("submit-btn" + id).click();
    }

    showCard(e) {
        let element = e.target,
            target = element.getAttribute('data-target');
        if (element.nodeName === "H5") {
            document.querySelector(target).classList.toggle('show');
        }
    }

    changeVariations(e, type = "standard") {
        let target = e.target,
            key = target.getAttribute('data-key'),
            step = target.getAttribute('data-step'),
            name = target.getAttribute('data-type'),
            value = target.value;
        //save it to standard
        let state = utility.objectCopy(this.state.standard);
        state[key][name] = parseInt(value) * parseInt(step);

        this.setState({[type]: state});
    }

    renderSnip(data,id) {
        return data.map((s,k) => (
            <span className="alert alert-dismissible alert-info snip mr-2" data-standard={id}>
              {s}
                <button type="button" className="close" data-dismiss="alert" aria-label="Close" data-id={k} data-standard={id} onClick={event => {
                    let target=event.target,
                        key=target.getAttribute('data-id'),
                        id=target.getAttribute('data-standard');
                    this.customLaufmeter("",id,key,"delete");
                }}> <span data-id={k} data-standard={id}>×</span> </button>
            </span>
        ));
    }

    customLaufmeter(data,profile,key=false,type="add"){
        let copyState=utility.objectCopy(this.state.standard);
        if(type==="add" && data){
            let arr=copyState[profile].customLaufmeter;
            if(typeof arr ==="object"){
                copyState[profile].customLaufmeter.push(data);
            }else{
                copyState[profile].customLaufmeter=[data];
            }

        }else if(type==="delete" && key !==false){
            copyState[profile].customLaufmeter.splice(key, 1);
        }
        this.setState({standard:copyState})
    }


    renderStandard() {
        return this.state.standard.map((s, key) => {
            let show = "",
                laufendeMeter = (parseInt(s.runninMeter) * 1000) - this.calculateLaufmeter(key),
                variations = 0;
            variations += s.ta ? parseInt(s.ta) : 0;
            variations += s.tb ? parseInt(s.tb) : 0;
            variations += s.tc ? parseInt(s.tc) : 0;

            laufendeMeter -= variations;
            if(s.customLaufmeter && s.customLaufmeter.length >0){
                let sum=utility.sumOfArray(s.customLaufmeter);
                laufendeMeter -= sum;
            }

            if (key === 0) {
                show = "show";
            }
            return (
                <div className="results mb-3 standard-overview" data-key={key} key={"results-standard-" + key}>
                    <h5 className="card-header border-0 pointer" onClick={e => this.showCard(e)}
                        data-target={"#results-standard-" + key + 1}>Standard Nr.{key + 1} <span
                        className="float-right icon icon-trash la-trash-alt las"
                        onClick={_ => this.removeResult(key, "standard")}></span>
                        <span className="float-right"
                              onClick={_ => this.edit(key, "standard")} style={{marginRight: 15}}>Edit</span>
                    </h5>
                    <div className={show + " card-body collapse"} id={"results-standard-" + key + 1}>
                        <div className="row">
                            <div className="col-lg-2 col-sm-12">
                                <div className="svg-container">
                                    <img src={s.productUrl} alt="res"/>
                                </div>
                            </div>
                            <div className="col-lg-5 col-sm-12">
                                <div className="product-side-container text-left">
                                    <span className="s-d-a mr-4">A-Maß: <strong>{s.da}</strong></span>
                                    <span className="s-d-b mr-4">B-Maß: <strong>{s.db}</strong></span>
                                    <span className="s-d-c mr-4">C-Maß: <strong>{s.dc}</strong></span>
                                    <h5 className="mb-2 mt-2 s-cross-slope">Quergefälle: <strong>{s.crossSlopeMM && parseFloat(s.crossSlopeMM).toFixed(4)}mm
                                        - {s.crossSlopeDeg}&deg;</strong></h5>
                                    <h5 className="mb-2 mt-2 s-running-meter">Laufende
                                        Meter: <strong>{s.runninMeter}</strong></h5>
                                    <h5 className="mb-2 mt-2 s-cutting-length">Zuschnittlänge: <strong>{s.cuttingLength}</strong>
                                    </h5>
                                    <h5 className="mb-2 s-sheet-thickness">Blechstärke: <strong>{s.sheetThickness}</strong>
                                    </h5>
                                    <h5 className="mb-2 s-bracket-space">Halterabstand: <strong>{s.bracketSpace}</strong>
                                    </h5>
                                    <h5 className="mb-2 s-color">Beschichtung: <strong>{s.color}</strong></h5>
                                    <h5 className="mb-2 s-color">Sonderfarbton: <strong>{s.sonderfarbton}</strong></h5>
                                </div>
                            </div>
                            <div className="col-lg-5 col-sm-12">
                                <h5>LaufendeMeter : {laufendeMeter} mm</h5>
                                <div className="row">
                                    <div className="col-4">
                                        <h5 className="card-title">3m: </h5>
                                        <div className="form-group">
                                            <input className="form-control length"
                                                   onChange={e => this.changeVariations(e)} data-type="ta"
                                                   data-step="3000" data-key={key} defaultValue={s.ta}
                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <h5 className="card-title">4m: </h5>
                                        <div className="form-group">
                                            <input className="form-control length"
                                                   onChange={e => this.changeVariations(e)} data-type="tb"
                                                   data-step="4000" data-key={key} defaultValue={s.tb}
                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <h5 className="card-title">5m: </h5>
                                        <div className="form-group">
                                            <input className="form-control length"
                                                   onChange={e => this.changeVariations(e)} data-type="tc"
                                                   data-step="5000" data-key={key} defaultValue={s.tc}
                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4 mt-1">
                                    <div className="input-group mb-3">
                                        <input type="number" className="form-control" ref={this.customLaufmeterTextBox} placeholder="Sondermaße" data-key={key} onKeyUp={event =>{
                                            if(event.keyCode===13){
                                                let target=event.target,
                                                    key=target.getAttribute('data-key'),
                                                    val=target.value;
                                                this.customLaufmeter(val,key);
                                                target.value="";
                                            }
                                        }} />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary" type="button" data-key={key} onClick={event => {
                                                let target=event.target,
                                                    key=target.getAttribute('data-key'),
                                                    input=target.closest('.input-group').querySelector('input'),
                                                    val=input.value;
                                                this.customLaufmeter(val,key);
                                                input.value='';
                                                input.focus();
                                            }}>+</button>
                                        </div>
                                    </div>
                                    {s.customLaufmeter && this.renderSnip(s.customLaufmeter,key)}
                                </div>

                                {laufendeMeter > 0 && (
                                    <div style={{"color": "red"}}>Bitte beachten Sie, dass Sie Ihre Laufmeter null oder
                                        weniger als null sein muss.</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    renderEquipments() {
        return this.state.equipments.map((s, key) => {
            let show = "";
            if (key === 0) {
                show = "show";
            }
            return (
                <div className="results mb-3" data-key={key} key={"results-equipments-" + key}>
                    <h5 className="card-header border-0 pointer" onClick={e => this.showCard(e)}
                        data-target={"#results-equipments-" + key + 1}>Equipments Nr.{key + 1} <span
                        className="float-right icon icon-trash la-trash-alt las"
                        onClick={_ => this.removeResult(key, "equipments")}></span>
                        {/*<span className="float-right"*/}
                        {/*      onClick={_ => this.edit(key, "equipments")} style={{marginRight:15}}>Edit</span>*/}
                    </h5>
                    <div className={show + " card-body collapse"} id={"results-equipments-" + key + 1}>
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <div className="svg-container">
                                    <img src={s.url} alt="res" width="200"/>
                                </div>
                            </div>
                            <div className="col-lg-9 col-sm-12">
                                <div className="product-side-container text-left">
                                    <h3>{s.selectedEq}</h3>

                                    {(s.selectedEq !== 'T-Formteil' && s.selectedEq !== 'Wechselecke') && (
                                        <h5 className="mb-2 mt-2 s-cross-slope">Blende: <strong>{s.Blende.label}</strong>
                                        </h5>
                                    )}

                                    {s.selectedEq === 'Aufkantung' && (
                                        <Fragment>

                                            <h5 className="mb-2 mt-2 s-cross-slope">Höhe der
                                                Aufkantung: <strong>{s.height}</strong></h5>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Länge der
                                                Aufkantung: <strong>{s.length}</strong></h5>
                                        </Fragment>
                                    )}

                                    {/*{(s.selectedEq === 'Aufkantung' || s.selectedEq === 'Endkappe') && (
                                        <Fragment>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Tafelmaß: <strong>{s.panelSize}</strong>
                                            </h5>
                                        </Fragment>
                                    )}*/}

                                    {(s.selectedEq === 'Außenecke' || s.selectedEq === 'Innenecke') && (
                                        <Fragment>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Winkel: <strong>{s.winkel}</strong>
                                            </h5>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Schenkellänge: <strong>{s.length}</strong>
                                            </h5>
                                        </Fragment>
                                    )}

                                    {s.selectedEq === 'Endkappe' && (
                                        <Fragment>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Maß der
                                                Sichtblende: <strong>{s.diemension}</strong></h5>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Länge
                                                Endkappe: <strong>{s.endcap}</strong></h5>
                                        </Fragment>
                                    )}

                                    {s.selectedEq === 'T-Formteil' && (
                                        <Fragment>
                                            <h5 className="mb-2 mt-2 s-cross-slope">Winkel: <strong>{s.winkel}</strong>
                                            </h5>
                                            <h5 className="mb-2 mt-2">Waagrechte
                                                Blende: <strong>{s['Waagrechte Blende'].label}</strong></h5>
                                            <h5 className="mb-2 mt-2">Senkrechte
                                                Blende: <strong>{s['Senkrechte Blende'].label}</strong></h5>
                                        </Fragment>
                                    )}

                                    {s.selectedEq === 'Wechselecke' && (
                                        <Fragment>
                                            <h5 className="mb-2 mt-2">Linke
                                                Blende: <strong>{s['Linke Blende'].label}</strong></h5>
                                            <h5 className="mb-2 mt-2">Rechte
                                                Blende: <strong>{s['Rechte Blende'].label}</strong></h5>
                                            <h5 className="mb-2 mt-2 ">Winkel: <strong>{s.winkel}</strong></h5>
                                            <h5 className="mb-2 mt-2">Schenkellänge Links: <strong>{s.links}</strong>
                                            </h5>
                                            <h5 className="mb-2 mt-2">Schenkellänge Rechts: <strong>{s.rechts}</strong>
                                            </h5>
                                        </Fragment>
                                    )}


                                    <h5 className="mb-2 mt-2 s-cross-slope">Menge der
                                        Formteile: <strong>{s.pieces}</strong></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    renderDrawing() {
        let alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
        return this.state.drawing.map((s, key) => {
            let show = "";
            if (key === 0) {
                show = "show";
            }
            let points = s.points.map((p, i) => {
                return (
                    <span className="mr-4 d-inline-block mb-5"><strong>{alphabet[i]}:</strong> <span
                        className="badge badge-info">Length:{p.length}</span>, <span
                        className="badge badge-secondary">Angle:{p.angle}&ang;</span></span>
                )
            });
            return (
                <div className="results mb-3" data-key={key} key={"results-drawing-" + key}>
                    <h5 className="card-header border-0 pointer" onClick={e => this.showCard(e)}
                        data-target={"#results-drawing-" + key + 1}>Individual Nr.{key + 1} <span
                        className="float-right icon icon-trash la-trash-alt las"
                        onClick={_ => this.removeResult(key, "drawing")}></span>
                    </h5>
                    <div className={show + " card-body collapse"} id={"results-drawing-" + key + 1}>
                        <div className="row">
                            <div className="col-12">
                                {points}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    componentDidMount() {
        if (this.props.match.url === '/individual' && window.resetVector) {
            window.resetVector();
        }
    }

    select(e, type = "equipment") {
        let element = e.target;
        if (element.nodeName === "IMG") { //check clicked tag
            element = element.closest('div');
        }
        let url = element.children[0].src,
            name = element.getAttribute('data-name'),
            active = parseInt(element.getAttribute('data-key')),
            activeKey = "currentEquipment";

        if (type === "product") {
            activeKey = "currentProduct";
        }

        if (name) {
            this.setState({[type]: name, [type + "Url"]: url, [activeKey]: active});
        }
    }

    onChange(e) {
        let element = e.target,
            type = element.getAttribute('data-type');

        if (type) {
            this.setState({[type]: element.value});
        }
    }

    showModal(show = "active") {
        this.setState({showModal: show})
    }

    finalSubmit() {
        axios.post('https://alpha.kantmanufaktur.com/mail.php', this.state).then(function (response) {
            console.log(response);
        }).catch(function (error) {
            console.log(error);
        });
    }

    edit(key, type) {
        this.setState({editId: key, currentEdit: type});
        this.props.history.push('/' + type);
    }

    resetEdit() {
        this.setState({editId: false, currentEdit: ""});
        document.querySelectorAll('form').forEach(e => {
            e.reset();
        }); //reset all forms
    }

    calculateLaufmeter(id) {
        let total = 0;
        this.state.equipments.forEach(e => {
            let pieces = parseInt(e.pieces);
            if (e.hasOwnProperty('Blende') && e['Blende'].value == id) { //check selected product, here it's id of standard/equipment
                if (e.selectedEq === 'Aufkantung') {
                    total += pieces * parseInt(e.length);
                } else if (e.selectedEq === 'Endkappe') {
                    total += pieces * parseInt(e.endcap);
                } else if (e.selectedEq === 'Außenecke' || e.selectedEq === 'Innenecke') {
                    total += pieces * (2 * parseInt(e.length));
                }
            } else if (e.hasOwnProperty('Waagrechte Blende') && e['Waagrechte Blende'].value == id) {
                total += pieces * (parseInt(e['links']));
            } else if (e.hasOwnProperty('Senkrechte Blende') && e['Senkrechte Blende'].value == id) {
                total += pieces * (parseInt(e['rechts']));
            } else if (e.hasOwnProperty('Linke Blende') && e['Linke Blende'].value == id) {
                total += pieces * (parseInt(e['links']));
            } else if (e.hasOwnProperty('Rechte Blende') && e['Rechte Blende'].value == id) {
                total += pieces * (parseInt(e['rechts']));
            }
        });
        return total;
    }

    render() {
        let url = this.props.match.url,
            standardVisilble = "d-none",
            drawingVisilble = "d-none",
            equipmentVisilble = "d-none",
            toolTipVisible = {"data-tip": true},
            standardEdit = this.state.currentEdit === "standard" ? this.state.standard[this.state.editId] : false,
            equipmentEdit = this.state.currentEdit === "equipments" ? this.state.equipments[this.state.editId] : false,
            navVisible = "";
        switch (url) {
            case '/':
                standardVisilble = "d-none";
                drawingVisilble = "d-none";
                equipmentVisilble = "d-none"
                navVisible = "";
                break;
            case '/individual':
                standardVisilble = "d-none";
                drawingVisilble = "";
                equipmentVisilble = "d-none"
                navVisible = "d-none";
                if (window.resetVector) {
                    window.resetVector();
                }
                break;
            case '/standard':
                standardVisilble = "";
                drawingVisilble = "d-none";
                navVisible = "d-none";
                equipmentVisilble = "d-none"
                break;
            case '/equipment':
                equipmentVisilble="";
                standardVisilble = "d-none";
                drawingVisilble = "d-none";
                navVisible = "d-none";
                break;
            default:
                break;
        }
        if (this.state.drawing.length > 0 || this.state.standard.length > 0) {
            toolTipVisible = {"data-tip-disable": true};
        }
        return (
            <Layout>
                <div className={navVisible + " row"}>

                    <Router>
                        <div className="text-center col-sm-12">
                            <Link to="/individual" className="">
                                <div className="card-selector">
                                    <img className="img-fluid" src={constants.IMG_URL + "drawing.svg"}
                                         alt="individual"/>
                                    <h3 className="text-center text-muted">Individual</h3>
                                </div>
                            </Link>
                            <Link to="/standard" className="">
                                <div className="card-selector">
                                    <img className="img-fluid" src={constants.IMG_URL + "standard.svg"} alt="standard"/>
                                    <h3 className="text-center text-muted">Standard</h3>
                                </div>
                            </Link>

                            <Link to="/equipment" className="">
                                <div className="card-selector" {...toolTipVisible} data-for='no-products'>
                                    <img className="img-fluid" src={constants.IMG_URL + "equipment.svg"}
                                         alt="equipment"/>
                                    <h3 className="text-center text-muted">Equipment</h3>
                                </div>
                                <ReactTooltip type="dark" id='no-products'>
                                    <span>Please add product to continue</span>
                                </ReactTooltip>
                            </Link>
                        </div>
                    </Router>
                </div>
                <div className="col-8">
                    <div id="canvas-container"></div>
                </div>
                <div className={drawingVisilble + " row"}>

                    <Drawing history={this.props.history} proxyClick={this.proxyClick} save={this.save}
                             resetEdit={this.resetEdit}
                             id={this.state.drawing.length + 1}/>

                </div>

                <div className={standardVisilble + " row"}>
                    {/*Here we passing standardVisible to reset local state of profiles*/}
                    <Standard edit={standardEdit} history={this.props.history} standardVisilble
                              proxyClick={this.proxyClick} resetEdit={this.resetEdit}
                              editId={standardEdit ? this.state.editId : false} save={this.save}
                              id={standardEdit ? this.state.editId + 1 : this.state.standard.length + 1}/>

                </div>

                <div className={equipmentVisilble + " row"}>

                    <Equipments prefix="d" history={this.props.history} proxyClick={this.proxyClick}
                                resetEdit={this.resetEdit}
                                standard={this.state.standard}
                                id={equipmentEdit ? this.state.editId + 1 : this.state.equipments.length + 1}
                                active={this.state.currentEquipment} equipments={this.state.equip}
                                showCard={this.showCard} select={this.select} save={this.save}/>
                </div>

                <div className={navVisible + " row mt-5"}>
                    <div className="content-side col-lg-11 col-md-12 col-sm-12">
                        {(this.state.drawing.length || this.state.standard.length) ? (
                            <h4 className="text-center">
                                <button className="btn-style-two button button--primary mb-4" onClick={() => {
                                    this.showModal("active")
                                }}>Send Enquiry
                                </button>
                            </h4>
                        ) : ""}
                        {this.renderEquipments()}
                        {this.renderStandard()}
                        {this.renderDrawing()}
                    </div>
                </div>

                <Modal active={this.state.showModal} id="contact-modal">
                    <div className="modal-head">
                        <h4> Anfrage absenden </h4>
                        <div className="modal-close" onClick={() => {
                            this.showModal("");
                        }}>
                        </div>
                    </div>
                    <div className="form-container">
                        <Form finalSubmit={this.finalSubmit} save={this.save}/>
                    </div>
                </Modal>
            </Layout>
        )
    }
}

export default Enquiry;
